import React from 'react'
import { Helmet } from 'react-helmet'

import { ENV } from '../constants/activity-constants'
var loaded = false
function isSSR() {
  return typeof window === 'undefined'
}
export default function CrazyEgg() {
  if (ENV === 'DEV') {
    return null
  }
  if (isSSR()) {
    return null
  }
  if (loaded) {
    return null
  }
  loaded = true
  return (
    <Helmet
      script={[
        {
          type: 'text/javascript',
          src: '//script.crazyegg.com/pages/scripts/0024/0375.js',
          async: 'async',
        },
      ]}
    />
  )
}
